"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIColorSwatch = _interopRequireDefault(require("UIComponents/color/UIColorSwatch"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _underscore = require("underscore");

var _default = _react.default.createClass({
  displayName: "DynoEditorSuggestedColors",
  propTypes: {
    updateColor: _react.default.PropTypes.func.isRequired,
    selectedColor: _react.default.PropTypes.string.isRequired,
    loading: _react.default.PropTypes.bool.isRequired,
    suggestedColors: _react.default.PropTypes.array
  },
  getDefaultProps: function getDefaultProps() {
    return {
      suggestedColors: []
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowCalloutEditor." + suffix;
  },
  handleSwatchSelection: function handleSwatchSelection(event) {
    this.props.updateColor(event.target.value);
  },
  getContent: function getContent(isLoading, selectedColor, suggestedColors) {
    var haveSuggestedColors = !isLoading && suggestedColors.length > 0;
    var content;

    if (isLoading) {
      content = this.getLoadingComponent();
    } else if (haveSuggestedColors) {
      content = this.getSuggestedColors(selectedColor, suggestedColors);
    } else {
      content = this.getFallbackColors(selectedColor);
    }

    return content;
  },
  getColorSwatches: function getColorSwatches(selectedColor, colors) {
    var _this = this;

    return (0, _underscore.map)(colors, function (color) {
      return _react.default.createElement(_UIColorSwatch.default, {
        key: color,
        color: color,
        borderColor: '#bcc3c5',
        size: 14,
        selected: selectedColor === color,
        onClick: _this.handleSwatchSelection
      });
    });
  },
  getSuggestedColors: function getSuggestedColors(selectedColor, suggestedColors) {
    var colorSwatches = this.getColorSwatches(selectedColor, suggestedColors);
    return _react.default.createElement("div", null, _react.default.createElement(_Small.default, {
      use: "help"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('existingColorsFoundMessage')
    })), _react.default.createElement("br", null), _react.default.createElement(_UIList.default, {
      className: "suggested-colors__list",
      inline: true
    }, colorSwatches));
  },
  getFallbackColors: function getFallbackColors(selectedColor) {
    var colorSwatches = this.getColorSwatches(selectedColor, ['#66A5E9', '#FF5550', '#F9FC32', '#AFDA80', '#D195DD', '#FF9842']);
    return _react.default.createElement("div", null, _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('colorSuggestions')
    })), _react.default.createElement(_UIList.default, {
      inline: true
    }, colorSwatches));
  },
  getLoadingComponent: function getLoadingComponent() {
    return _react.default.createElement("p", {
      className: "suggested-colors__loading"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('loadingColorSuggestions')
    }));
  },
  render: function render() {
    var _this$props = this.props,
        loading = _this$props.loading,
        suggestedColors = _this$props.suggestedColors,
        selectedColor = _this$props.selectedColor;
    var content = this.getContent(loading, selectedColor, suggestedColors);
    return _react.default.createElement("div", {
      className: "suggested-colors"
    }, content);
  }
});

exports.default = _default;
module.exports = exports.default;